import React, { useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import './caurosel.scss';

const Caurosel = ({playerChosen, setPlayerChosen, showStemPlayer, setShowStemPlayer}) => { 
    let ref = useRef();
    let [selectedPlayer, setSelectedPlayer] = useState(undefined);
    let [mouse, setMouse] = useState();
    let [over, setOver] = useState();

    const onMouseMove = useCallback((e) => {
        let rect = ref.current.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;
        setMouse({x,y});
    }, [setMouse]);

    const onMouseLeave = useCallback(() => {
        setMouse(undefined);
    }, [setMouse]);

    let brect = ref.current && ref.current.getBoundingClientRect();

    useEffect(() => {
        console.log("over=", over);
    }, [over]);
    let className = "caurosel";
    if (playerChosen) {
        className += " player-chosen";
    }
    return (
        <div onMouseLeave={onMouseLeave} ref={ref} onMouseMove={onMouseMove} className={className}>
          {mouse && <div className="mouse-radial" style={{left: mouse.x-500, top: mouse.y-500}}></div>}
          <SporeOption
            playerChosen={playerChosen}
            brect={brect}
            setShowStemPlayer={setShowStemPlayer}
            showStemPlayer={showStemPlayer}
            mouse={mouse}
            isOver={over===1}
            setOver={setOver}
           setPlayerChosen={setPlayerChosen} rarity="Convolver" tokenId={1} thumbnail={"/sp-1-thumbnail.png"}/>
          <SporeOption
            setShowStemPlayer={setShowStemPlayer}
            showStemPlayer={showStemPlayer}
            brect={brect}
            playerChosen={playerChosen}
            mouse={mouse}
            isOver={over===2}
            setOver={setOver}
            setPlayerChosen={setPlayerChosen} rarity="Ionic Filter" tokenId={2} thumbnail={"/sp-2-thumbnail.png"}/>
          <SporeOption
            setShowStemPlayer={setShowStemPlayer}
            showStemPlayer={showStemPlayer}
            brect={brect}
            playerChosen={playerChosen}
            mouse={mouse}
            isOver={over===3}
            setOver={setOver}
            setPlayerChosen={setPlayerChosen} rarity="WaveFolder" tokenId={3} thumbnail={"/sp-3-thumbnail.png"}/>
        </div>);
};

const SporeOption = ({
    showStemPlayer,
    setShowStemPlayer,
    brect,
    tokenId, playerChosen, isOver, mouse, setOver, rarity, thumbnail, setPlayerChosen}) => {
    let ref= useRef();

    let rect = ref.current && ref.current.getBoundingClientRect();
    let _x = rect && mouse && mouse.x - rect.left + brect.left;
    let _y= rect && mouse && mouse.y - rect.top + brect.top;
    let className = "spore-player-option";
    if (playerChosen === tokenId) {
        className += " chosen";
    } else if (playerChosen) {
        className += " unchosen";
    }
    return (
        <div
          ref={ref}
          onMouseOver={() => setOver(tokenId)}
          onClick={() => {
              if (showStemPlayer) {
                  setShowStemPlayer(undefined);
                  return;
              }
              if (playerChosen === tokenId) {
                  setPlayerChosen(undefined);
              } else {
                  setPlayerChosen(tokenId);
              }
          }}
          className={className}>
          {isOver && mouse && <div className="mouse-radial" style={{left: _x-500, top: _y-500}}></div>}
          <img src={thumbnail}/>
          <div className="sp-fields">
            <div className="sp-name">
              SP-{tokenId}
            </div>
            <div className="sp-rarity">
              {rarity}
            </div>
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Caurosel);
